/**
 * Route for `contests`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ContestsPage } from "../features/contests/ContestsPage";

export const contestsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/contests",
	component: ContestsPage,
});

export default contestsRoute;
